import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberSuffixPipe'
})
export class NumberSuffixPipePipe implements PipeTransform {

  transform(value: any): string {
    if(typeof(value) === "string") {
      value = Number(value);
    }
    if (value >= 1_000_000_000) {
      return (value / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    }
    if (value >= 1_000_000) {
      return (value / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (value >= 1_000) {
      return (value / 1_000).toFixed(1).replace(/\.0$/, '') + 'k';
    }
    return value.toString();
  }

}
